import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../../components/PaginaToolbar";
import Form, { SimpleItem, Label, GroupItem } from "devextreme-react/form";
import { Button } from "devextreme-react";
import {
  criarImovelDs,
  criarBairroDs,
  criarLoteamentoDs,
  criarResponsavelTecnicoDs,
} from "../../DataSources";
import uiInfo from "../../ui-info";
import memoria from "../../Memoria";
import apiAxios from "../../api-axios";
import apiRelatorios from "../../api-reports";
import UserInfo from "../../UserInfo";
import openReport from "../../openReport";
import ShowError from "../../AppServices";
import { ScrollView } from "devextreme-react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import MapContainer from "../../components/googleMapsApi/index";
import TiposAlvaraConstrucaoBox from "../tiposAlvaraConstrucao/TiposAlvaraConstrucaoBox";

const filtroLimpo = {
  sequencial: null,
  distritoCartografia: null,
  setorCartografia: null,
  quadraCartografia: null,
  faceCartografia: null,
  loteCartografia: null,
  unidadeCartografia: null,
  natureza: -1,
  posicaoFiscalIptu: -1,
  posicaoPatrimonial: -1,
  sequencialContribuinte: null,
  nomeLogradouro: null,
  bairroId: null,
  loteamentoId: null,
  lote: null,
  quadra: null,
  inativo: 1,
  nomeContribuinte: null,
  numero: null,
  mapeamento: 0,
  areaEdificada: null,
  cpfCnpj: null,
  matricula: null
};

export default class ImovelBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: { ...filtroLimpo },
      showMap: undefined,
      latitude: undefined,
      longitude: undefined,
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.imovelDs = criarImovelDs();
    this.imprimirRelatorioImovel = this.imprimirRelatorioImovel.bind(this);

    this.printOptions = {
      url: "report/imprimir_imoveis_box",
      fnFiltrar: () => this.filtrar(),
      fnDadosFiltro: () => this.state.filtro,
      fnItemConvert: (e) => this.imprimirItemConvert(e)
    };


  }

  imprimirItemConvert(item) {
    console.log("imovel item", item);
    const newItem = {
      contribuinte: item.contribuinte.nomeECodigo,
      endereco: item.enderecoSemCidade,
      sequencial: item.sequencial,
      cartografia: item.cartografiaFormatada,
      natureza: item.naturezaStr,
      posicaoFiscal: item.posicaoFiscalStr
    };
    console.log(newItem);
    return newItem;

  }


  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];

    if (filtro.sequencial !== null) {
      filtroCorrente.push(["sequencial", "=", filtro.sequencial]);
    }
    if (
      filtro.distritoCartografia !== null &&
      filtro.distritoCartografia !== ""
    ) {
      filtroCorrente.push([
        "distritoCartografia",
        "=",
        filtro.distritoCartografia,
      ]);
    }
    if (filtro.setorCartografia !== null && filtro.setorCartografia !== "") {
      filtroCorrente.push(["setorCartografia", "=", filtro.setorCartografia]);
    }
    if (filtro.quadraCartografia !== null && filtro.quadraCartografia !== "") {
      filtroCorrente.push(["quadraCartografia", "=", filtro.quadraCartografia]);
    }
    if (filtro.faceCartografia !== null && filtro.faceCartografia !== "") {
      filtroCorrente.push(["faceCartografia", "=", filtro.faceCartografia]);
    }
    if (filtro.loteCartografia !== null && filtro.loteCartografia !== "") {
      filtroCorrente.push(["loteCartografia", "=", filtro.loteCartografia]);
    }
    if (
      filtro.unidadeCartografia !== null &&
      filtro.unidadeCartografia !== ""
    ) {
      filtroCorrente.push([
        "unidadeCartografia",
        "=",
        filtro.unidadeCartografia,
      ]);
    }
    if (filtro.natureza !== null && filtro.natureza !== -1) {
      filtroCorrente.push(["natureza", "=", filtro.natureza]);
    }
    if (filtro.posicaoFiscalIptu !== null && filtro.posicaoFiscalIptu !== -1) {
      filtroCorrente.push(["posicaoFiscalIptu", "=", filtro.posicaoFiscalIptu]);
    }
    if (
      filtro.posicaoPatrimonial !== null &&
      filtro.posicaoPatrimonial !== -1
    ) {
      filtroCorrente.push([
        "posicaoPatrimonial",
        "=",
        filtro.posicaoPatrimonial,
      ]);
    }
    if (filtro.sequencialContribuinte !== null) {
      filtroCorrente.push([
        "contribuinte.sequencial",
        "=",
        filtro.sequencialContribuinte,
      ]);
    }
    if (filtro.nomeContribuinte !== null && filtro.nomeContribuinte !== "") {
      filtroCorrente.push([
        "contribuinte.nome",
        "contains",
        filtro.nomeContribuinte.trim(),
      ]);
    }
    if (filtro.nomeLogradouro !== null && filtro.nomeLogradouro !== "") {
      filtroCorrente.push([
        "logradouro.nome",
        "contains",
        filtro.nomeLogradouro.trim(),
      ]);
    }
    if (filtro.numero !== null && filtro.numero !== "") {
      filtroCorrente.push(["numero", "=", filtro.numero.trim()]);
    }
    if (filtro.bairroId !== null && filtro.bairroId !== "") {
      filtroCorrente.push(["bairroId", "=", filtro.bairroId]);
    }
    if (filtro.loteamentoId !== null && filtro.loteamentoId !== "") {
      filtroCorrente.push(["loteamentoId", "=", filtro.loteamentoId]);
    }
    if (filtro.inativo !== null && filtro.inativo !== -1) {
      filtroCorrente.push(["inativo", "=", filtro.inativo == 0]);
    }
    if (filtro.lote !== null && filtro.lote !== "") {
      filtroCorrente.push(["lote", "contains", filtro.lote.trim()]);
    }
    if (filtro.quadra !== null && filtro.quadra !== "") {
      filtroCorrente.push(["quadra", "contains", filtro.quadra.trim()]);
    }
    if (filtro.matricula !== null && filtro.matricula !== "") {
      filtroCorrente.push(["matricula", "contains", filtro.matricula.trim()]);
    }
    if (filtro.mapeamento && filtro.mapeamento === 1) {
      filtroCorrente.push(["chaveMigracao", "contains", "sgtweb_mapeamento"]);
    }
    if (filtro.areaEdificada) {
      filtroCorrente.push(["areaEdificada", "=", filtro.areaEdificada]);
    }
    if (filtro.cpfCnpj && filtro.cpfCnpj.trim() != "") {
      const cpfCnpjFiltro = filtro.cpfCnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      filtroCorrente.push(["contribuinte.cpfCnpj", "contains", cpfCnpjFiltro]);
    }
    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  componentDidMount() {
    memoria.redirecionarSeNecessario(this.props.location, this.props.history);
  }

  limparFiltro(e) {
    this.setState({ filtro: { ...filtroLimpo } });
    this.filtrar();
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("imoveis/editar/" + e.data.id);
  }

  imprimirRelatorioImovel({ data }) {
    apiRelatorios
      .post(`/report/bci/${data.id}/${UserInfo.getPrefeitura()}`)
      .then((response) => {
        if (response.status === 200) {
          openReport(response.data);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          ShowError(error.response.data.erros);
        } else {
          ShowError(error.message);
        }
      });
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={this.filtrar}>
          <Form
            id="frmPesquisa"
            formData={this.state.filtro}
            colCount={10}
            labelLocation={"top"}
          >
            <SimpleItem
              dataField="sequencial"
              editorType={"dxNumberBox"}
              colSpan={1}
              editorOptions={{ format: uiInfo.formatoNumerico.inteiroSemPonto }}
            >
              <Label text="Inscrição" />
            </SimpleItem>

            <GroupItem colSpan={3} colCount={6}>
              <SimpleItem
                dataField="distritoCartografia"
                editorType="dxNumberBox"
                colSpan={1}
                cssClass={"remover-offset"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.inteiroSemPonto,
                }}
              >
                <Label text="Distrito" />
              </SimpleItem>
              <SimpleItem
                dataField="setorCartografia"
                editorType="dxNumberBox"
                colSpan={1}
                cssClass={"remover-offset"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.inteiroSemPonto,
                }}
              >
                <Label text="Setor" />
              </SimpleItem>
              <SimpleItem
                dataField="quadraCartografia"
                editorType="dxNumberBox"
                colSpan={1}
                cssClass={"remover-offset"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.inteiroSemPonto,
                }}
              >
                <Label text="Quadra" />
              </SimpleItem>
              <SimpleItem
                dataField="faceCartografia"
                editorType="dxNumberBox"
                colSpan={1}
                cssClass={"remover-offset"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.inteiroSemPonto,
                }}
              >
                <Label text="Face" />
              </SimpleItem>
              <SimpleItem
                dataField="loteCartografia"
                editorType="dxNumberBox"
                colSpan={1}
                cssClass={"remover-offset"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.inteiroSemPonto,
                }}
              >
                <Label text="Lote" />
              </SimpleItem>
              <SimpleItem
                dataField="unidadeCartografia"
                editorType="dxNumberBox"
                colSpan={1}
                cssClass={"remover-offset"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.inteiroSemPonto,
                }}
              >
                <Label text="Unidade" />
              </SimpleItem>
            </GroupItem>

            <SimpleItem
              dataField="natureza"
              editorType={"dxSelectBox"}
              editorOptions={{
                dataSource: [
                  { id: -1, descricao: "Todos" },
                  { id: 0, descricao: "Predial" },
                  { id: 1, descricao: "Territorial" },
                ],
                valueExpr: "id",
                displayExpr: "descricao",
              }}
              colSpan={2}
            >
              <Label text="Natureza" />
            </SimpleItem>
            <SimpleItem
              dataField="posicaoFiscalIptu"
              editorType={"dxSelectBox"}
              editorOptions={{
                dataSource: [
                  { id: -1, descricao: "Todos" },
                  { id: 0, descricao: "Tributável" },
                  { id: 1, descricao: "Imune" },
                  { id: 2, descricao: "Isento" },
                ],
                valueExpr: "id",
                displayExpr: "descricao",
              }}
              colSpan={2}
            >
              <Label text="Posição Fiscal" />
            </SimpleItem>

            <SimpleItem
              dataField="mapeamento"
              editorType={"dxSelectBox"}
              editorOptions={{
                dataSource: [
                  { id: 0, descricao: "Todos" },
                  { id: 1, descricao: "Sim" },
                  { id: 2, descricao: "Não" },
                ],
                valueExpr: "id",
                displayExpr: "descricao",
              }}
              colSpan={2}
            >
              <Label text="Mapeamento" />
            </SimpleItem>

            <SimpleItem
              dataField="sequencialContribuinte"
              editorType="dxNumberBox"
              editorOptions={{ format: uiInfo.formatoNumerico.inteiroSemPonto }}
            >
              <Label text="IMC" />
            </SimpleItem>

            <SimpleItem dataField="nomeContribuinte" colSpan={3}>
              <Label text="Nome/Razão Social" />
            </SimpleItem>

            <SimpleItem dataField="cpfCnpj" colSpan={2} editorOptions={{ showClearButton: true }}>
              <Label text="CPF/CNPJ" />
            </SimpleItem>

            <SimpleItem dataField="nomeLogradouro" colSpan={3}>
              <Label text="Nome do Logradouro" />
            </SimpleItem>

            <SimpleItem dataField="numero" colSpan={1}>
              <Label text="Nº" />
            </SimpleItem>


            <SimpleItem
              dataField="areaEdificada"
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.n2, showClearButton: true }}
              cssClass={"txtFrmCpbsNumerico"}

            >
              <Label text="Área Edif. (m²)" />
            </SimpleItem>

            <SimpleItem
              dataField="bairroId"
              editorType={"dxSelectBox"}
              editorOptions={{
                showClearButton: true,
                dataSource: criarBairroDs(),
                valueExpr: "id",
                displayExpr: "descricao",
              }}
              colSpan={3}
            >
              <Label text="Bairro" />
            </SimpleItem>
            <SimpleItem
              dataField="loteamentoId"
              editorType={"dxSelectBox"}
              editorOptions={{
                showClearButton: true,
                dataSource: criarLoteamentoDs(),
                valueExpr: "id",
                displayExpr: "descricao",
              }}
              colSpan={2}
            >
              <Label text="Loteamento" />
            </SimpleItem>

            <SimpleItem dataField="quadra" colSpan={1}>
              <Label text="Quadra" />
            </SimpleItem>

            <SimpleItem dataField="lote" colSpan={1}>
              <Label text="Lote" />
            </SimpleItem>

            <SimpleItem dataField="matricula" colSpan={1}>
              <Label text="Mat. Cartório" />
            </SimpleItem>

            <SimpleItem
              dataField="inativo"
              editorType={"dxSelectBox"}
              editorOptions={{
                dataSource: [
                  { id: -1, descricao: "Todos" },
                  { id: 1, descricao: "Ativo" },
                  { id: 0, descricao: "Inativo" },
                ],
                valueExpr: "id",
                displayExpr: "descricao",
              }}
              colSpan={1}
            >
              <Label text="Situação" />
            </SimpleItem>
          </Form>
          <div style={{ marginTop: "10px" }}>
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Limpar Filtro" onClick={this.limparFiltro} />
            </div>
          </div>
        </form>
        <br />
        <PaginaToolbar
          titulo="Imóveis"
          novoCb={this.novoImovel.bind(this)}
          printOptions={this.printOptions}
        >
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            remoteOperations={true}
            dataSource={this.imovelDs}
            showBorders={true}
            rowAlternationEnabled={true}
            columnAutoWidth={true}
            focusedRowEnabled={true}
            wordWrapEnabled={window.innerWidth < 800}
            filterSyncEnabled={true}
            allowColumnReordering={true}
            onEditingStart={this.onAtualizandoRow}
          >
            <Editing
              allowDeleting={!this.usadoComoPesquisa}
              allowUpdating={!this.usadoComoPesquisa}
              useIcons={true}
              visible={!this.usadoComoPesquisa}
            />

            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              buttons={[
                "edit",
                "delete",
                {
                  hint: "Selecionar",
                  icon: "repeat",
                  visible: this.usadoComoPesquisa,
                  onClick: this.onSelecionado,
                },
                {
                  hint: "Imprimir Relatório",
                  icon: "exportpdf",
                  visible: !this.usadoComoPesquisa,
                  onClick: ({ row }) => this.imprimirRelatorioImovel(row),
                },
                {
                  hint: "Ver no Mapa",
                  icon: "map",
                  visible: !this.usadoComoPesquisa,
                  onClick: ({ row }) =>
                    this.setState({
                      latitude: row.data.coordenadaX,
                      longitude: row.data.coordenadaY,
                      showMap: true,
                    }),
                },
              ]}
            />
            <Column
              dataField={"id"}
              caption={"#"}
              width={"50px"}
              visible={false}
            />
            <Column
              dataField={"prefeituraId"}
              caption={"Prefeitura"}
              visible={false}
            >
              <FormItem visible={false}></FormItem>
            </Column>
            <Column
              dataField={"sequencial"}
              caption={"#"}
              width={"80px"}
              alignment={"center"}
            />
            <Column
              dataField={"cartografiaFormatada"}
              caption={"Cartografia"}
              width={160}
            />
            <Column
              dataField={"naturezaStr"}
              width={110}
              caption={"Natureza"}
            />
            <Column
              dataField={"posicaoFiscalStr"}
              caption={"Posição Fiscal"}
              width={120}
            />
            <Column
              dataField={"contribuinte.sequencial"}
              width={"80px"}
              alignment={"center"}
              caption={"IMC"}
            />
            <Column dataField={"contribuinte.nome"} caption={"Contribuinte"} />
            <Column dataField={"contribuinte.cpfCnpjFormatado"} caption={"CPF/CNPJ"} visible={false} />
            <Column dataField={"logradouro.nomeCompleto"} caption="Logradouro" />
            <Column dataField={"numero"} caption={"N.º"} />
            <Column dataField={UserInfo.getPrefeitura() == 31 ? "complementoObs" : "complemento"} caption={"Complemento"} />
            <Column dataField={"bairro.descricao"} caption={"Bairro"} />
            <Column dataField={"situacaoStr"} caption={"Situação"} />
            <Column
              dataField={"areaLote"}
              caption={"Área Lote"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
              visible={false}
            />
            <Column
              dataField={"areaEdificada"}
              caption={"Área Edificada"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
              visible={false}
            />

            <Column
              dataField={"loteamento.descricao"}
              caption={"Loteamento"}
              visible={false}
            />

            <Column
              dataField={"matricula"}
              caption={"Mat. Cartório"}
              format={uiInfo.formatoNumerico.n2}
              visible={false}
            />

            <Column
              dataField={"quadra"}
              caption={"Loteamento Quadra"}
              visible={false}
            />

            <Column
              dataField={"lote"}
              caption={"Loteamento Lote"}
              visible={false}
            />

            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

            <Pager
              showInfo={true}
              showNavigationButtons={true}
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
        <Popup
          visible={this.state.showMap}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={false}
          showTitle={true}
          title={"Localização"}
          onHiding={() => this.setState({ showMap: false })}
          width="100%"
          height="100%"
          maxWidth="700px"
          maxHeight="500px"
        >
          <ScrollView>
            <div>
              <MapContainer
                latitude={this.state.latitude}
                longitude={this.state.longitude}
              />
            </div>
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              width: 150,
              onClick: () => this.setState({ showMap: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </div>
    );
  }

  novoImovel() {
    this.props.history.push("imoveis/novo");
  }
}
